import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a34e2dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container px-0 py-9",
  id: "wrapper-div"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Import af Emissionsfaktorer", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Emissionscoefficienter allerede indlæst i systemet", -1))
const _hoisted_4 = {
  class: "d-flex align-items-center mb-4",
  id: "check-box-section"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "mono-lingual-select",
  class: "ml-2"
}, " Kun Danske ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "newest-version-select",
  class: "ml-2"
}, " Nyeste version ", -1))
const _hoisted_7 = {
  id: "section1",
  class: "py-9"
}
const _hoisted_8 = {
  class: "table--responsive-scroll",
  style: {"max-height":"550px","min-width":"680px","overflow":"auto"}
}
const _hoisted_9 = {
  class: "table",
  id: "existing-emf-data-table"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("caption", null, "Ekisterende imports", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "År", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Version", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Land", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Antal", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Fremskrevet", -1))
const _hoisted_16 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { "aria-colspan": "5" }, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "5" }, "Ingen rækker at vise")
], -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  id: "section2",
  class: "py-9"
}
const _hoisted_22 = { class: "d-flex justify-content-center mt-4" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "button button-secondary adjust-button-size",
  onclick: "document.getElementById('upload-file2').click()"
}, "Vælg en excelfil", -1))
const _hoisted_24 = { class: "d-flex justify-content-center mt-4" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "same-version-all-year",
  class: "ml-2"
}, "Importer som fremskrevet", -1))
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-md-3" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "form-input-1" }, "År:", -1))
const _hoisted_29 = { class: "col-md-3" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "form-input-2" }, "Version:", -1))
const _hoisted_31 = { class: "d-flex justify-content-center mt-4" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = {
  class: "table--responsive-scroll",
  style: {"height":"550px","overflow":"auto"}
}
const _hoisted_37 = { class: "table w-percent-100" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("caption", null, null, -1))
const _hoisted_39 = {
  key: 0,
  id: "excel-file-name",
  colspan: "5",
  style: {"text-align":"center"}
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"15%"},
      id: "validate_error_type"
    }, "Type"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"40%"},
      id: "validate_error_description"
    }, "Beskrivelse"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"45%"},
      id: "validate_error_value"
    }, "Værdi")
  ])
], -1))
const _hoisted_41 = { style: {"width":"15%"} }
const _hoisted_42 = { style: {"width":"40%"} }
const _hoisted_43 = { style: {"width":"45%"} }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_47 = {
  key: 1,
  class: "container px-0 py-9"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.pageAccess)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("form", {
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.importEmissionsFactor && _ctx.importEmissionsFactor(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "mono-lingual-select",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.onlyDanishEMF) = $event)),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmCheckboxDKValue())),
              class: "form-checkbox checkbox-medium"
            }, null, 512), [
              [_vModelCheckbox, _ctx.onlyDanishEMF]
            ]),
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "newest-version-select",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.onlyNewestVersion) = $event)),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.confirmCheckboxNewestVersionValue())),
              class: "form-checkbox checkbox-medium"
            }, null, 512), [
              [_vModelCheckbox, _ctx.onlyNewestVersion]
            ]),
            _hoisted_6
          ])
        ], 32),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("thead", null, [
                _createElementVNode("tr", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortBy('year')))
                }, _hoisted_16)
              ]),
              (_ctx.existingEmfImport)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.existingEmfImport, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: `item_${item.year}_${index}`
                      }, [
                        _createElementVNode("td", null, _toDisplayString(item.year), 1),
                        _createElementVNode("td", null, _toDisplayString(item.version), 1),
                        _createElementVNode("td", null, _toDisplayString(item.countryCode), 1),
                        _createElementVNode("td", null, _toDisplayString(item.numberEMC), 1),
                        _createElementVNode("td", null, _toDisplayString(item.actual ? 'Nej' : 'Ja'), 1)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_18, _hoisted_20))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createTextVNode("    "),
            _createElementVNode("input", {
              type: "file",
              id: "upload-file2",
              style: {"display":"none"},
              onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addFile && _ctx.addFile(...args)))
            }, null, 32),
            _createTextVNode(" " + _toDisplayString(this.excelFileName.fileName) + " ", 1)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "same-version-all-year",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isForecast) = $event)),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isForecastCheckbox())),
              class: "form-checkbox checkbox-medium",
              title: "Er import en fremskrinving"
            }, null, 512), [
              [_vModelCheckbox, _ctx.isForecast]
            ]),
            _hoisted_25,
            _createTextVNode("  ")
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "form-input-1",
                class: "form-control",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.year) = $event)),
                placeholder: "f.eks. 2015"
              }, null, 512), [
                [_vModelText, _ctx.year]
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "form-input-2",
                class: "form-control",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.version) = $event)),
                placeholder: "f.eks. 2"
              }, null, 512), [
                [_vModelText, _ctx.version]
              ]),
              _createTextVNode("  ")
            ]),
            _createElementVNode("div", _hoisted_31, [
              (_ctx.canImport)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "button button-secondary adjust-button-size",
                    disabled: _ctx.disableImport(),
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.importEmissionsFactor && _ctx.importEmissionsFactor(...args)))
                  }, "Importer", 8, _hoisted_32))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "button button-secondary adjust-button-size",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.exportToSqlString && _ctx.exportToSqlString(...args)))
              }, "Export til SQL"),
              _createTextVNode("  "),
              _createElementVNode("button", {
                class: "button button-secondary adjust-button-size",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.deleteEMC()))
              }, "Slet")
            ])
          ])
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("b", null, _toDisplayString(this.status), 1)
        ]),
        (_ctx.validationErrors.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              (this.excelFileName.fileName)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_34, "Validerings Log (" + _toDisplayString(_ctx.validationErrors.length) + ") ", 1))
                : (_openBlock(), _createElementBlock("h2", _hoisted_35, "Validerings Log")),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("table", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      (this.excelFileName.fileName)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_39, _toDisplayString(this.excelFileName.fileName), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _hoisted_40,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validationErrors, (item) => {
                      return (_openBlock(), _createElementBlock("tr", { key: item }, [
                        _createElementVNode("td", _hoisted_41, _toDisplayString(item.name), 1),
                        _createElementVNode("td", _hoisted_42, _toDisplayString(item.value), 1),
                        _createElementVNode("td", _hoisted_43, _toDisplayString(item.description), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_44, [
              (this.excelFileName.fileName)
                ? (_openBlock(), _createElementBlock("p", _hoisted_45, [
                    _createTextVNode(_toDisplayString(this.importSucces ? 'Import done!!' : ''), 1),
                    _hoisted_46
                  ]))
                : _createCommentVNode("", true)
            ]))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_47, "Din brugerprofil har ikke adgang til dette skærmbillede"))
}